import { Vector2 } from 'touchcontroller';
import { Rect } from './Rect';

export class Anchor {
    constructor(
        public rect: Rect,
        public type: string,
        public relativePosition: Vector2,
    ) {}

    get position() {
        return this.relativePosition
            .rotate(this.rect.rotation)
            .add(this.rect.shadowBoundingBox.topLeft);
    }
}
